/**
 * Configuration for different event types. The 'name' field is used to match the Prospect.Steps table,
 * but 'labelKey' is the i18n key for the step that determines what label the user sees.
 */
export default [
  {
    name: "Prospect",
    labelKey: "processSteps.prospect",
    color: "#91b6bb",
    textColor: "#fff",
  },
  {
    name: "Meet & Greet",
    labelKey: "processSteps.meetAndGreet",
    color: "#cc3300",
    textColor: "#fff",
  },
  {
    name: "Napkin Plan",
    labelKey: "processSteps.napkinPlan",
    color: "#ea6217",
    textColor: "#fff",
  },
  {
    name: "One-on-One",
    labelKey: "processSteps.oneOnOne",
    color: "#f7931e",
    textColor: "#fff",
  },
  {
    name: "Board Plan",
    labelKey: "processSteps.boardPlan",
    color: "#0087d4",
    textColor: "#fff",
  },
  {
    name: "Follow Up",
    labelKey: "processSteps.followUp",
    color: "#008797",
    textColor: "#fff",
  },
  {
    name: "Open Meeting",
    labelKey: "processSteps.openMeeting",
    color: "#00c4d3",
    textColor: "#fff",
  },
  {
    name: "Budget Session",
    labelKey: "processSteps.budgetSession",
    color: "#39b54a",
    textColor: "#fff",
  },
  {
    name: "Major Function",
    labelKey: "processSteps.majorFunction",
    color: "#006837",
    textColor: "#fff",
  },
];
